import { useId } from 'react';

import { FOCO_VISIVEL } from 'utils/foco';

import ModalDoCatalogo from './ModalDoCatalogo';
import RegrasDeUso from './RegrasDeUso';

interface ModalDeRegrasProps {
  isOpen: boolean;
  escolha: string;
  regras: string[];
  onFechar: () => void;
}

/** "Regras de uso" da experiência escolhida, em sequência e sem carrossel (CAT-36). */
export default function ModalDeRegras({ isOpen, escolha, regras, onFechar }: ModalDeRegrasProps) {
  const tituloId = useId();
  const escolhaId = useId();

  return (
    <ModalDoCatalogo isOpen={isOpen} tituloId={tituloId} descricaoId={escolhaId} onFechar={onFechar} rotuloFechar="Fechar modal de regras de uso">
      <h2 id={tituloId} className="m-0 inline-block rounded-md bg-brand-yellow px-[9px] py-1 font-text text-[12px] font-bold text-brand-blue-dark">
        Regras de uso
      </h2>
      <p id={escolhaId} className="m-0 mt-3 pr-8 font-display text-[17px] font-bold leading-[1.25] text-brand-blue-dark">
        {escolha}
      </p>
      <div tabIndex={0} role="region" aria-label="Regras de uso da experiência" className={`mt-4 max-h-[50vh] overflow-y-auto pr-1 ${FOCO_VISIVEL}`}>
        <RegrasDeUso paginas={regras} />
      </div>
      <button
        type="button"
        onClick={onFechar}
        className={`mt-6 flex w-full cursor-pointer items-center justify-center rounded-md border-0 bg-brand-blue px-5 py-[13px] font-text text-[13px] font-bold uppercase tracking-[0.04em] text-brand-white hover:bg-brand-blue-dark ${FOCO_VISIVEL}`}
      >
        Fechar
      </button>
    </ModalDoCatalogo>
  );
}
